<template>
    <div class="lw-cols  align-items-stretch one-row one-row-tl one-row-tp one-row-sl one-row-sp js-can-edit-element js-can-add-element" data-node-type="coursesWrapper">
        <course-card v-for="course,index in courses" :courseData="course" :cardTemplate="'courseCardTpl1'" :key="index"></course-card>
    </div>
</template>


<script>
    import PageComponentMixin from '../mixins/PageComponentMixin';
    import CourseCard from './CourseCard.vue';
    import { mapState } from 'vuex';
    import { mapActions } from 'vuex';

    const schema = {
        type: 'courseswrapper',
        config: {

        },

    }

    export default {
        name: 'CoursesWrapper',
        mixins : [PageComponentMixin],
        schema,
        data () {
            return {

            }
        },
        computed : {
            ...mapState('products',[
                'courses'
            ])
        },
        mounted () {
            this.LOAD_PRODUCTS();
        },
        methods : {
            ...mapActions('products',[
                'LOAD_PRODUCTS'
            ])
        },
        components : {
            CourseCard
        },
    }
</script>
